import React from 'react';
import IconCross from '../../../assets/icons/cross-icon.svg';
import './FilterReset.scss';

interface IFilterResetProps {
  label: string;
  onRemove: () => void;
}
const FilterReset = ({ label, onRemove }: IFilterResetProps) => (
  <button type='button' className={'filterResetContainer'} onClick={onRemove}>
    <IconCross />
    <span>{label}</span>
  </button>
);

export { FilterReset };
